/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * **EXPERIMENTAL** - This icon is still under development, and may change visually.
 *
 *![ExperimentalMicrophoneSparkleMutedIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB3ElEQVR4nM2VO0skQRDHVxMFNfHxBU4TNTISI6OFBbceCm3ViiIGaqKZ8e0lBpfe41PcJ/AOEVzEC447xAeYmxkYaKLgg5rt2R3XXad3NLiChqar5/fv/nd3TS6XCETsA5Z/1qyfzL1LEJXWkfXRt9UsjGKxNAgsv4F171lienm5G0jPYgFgPbWx5Bwk2UWWS2D5wSzDzeDIchQxSA+rHyH22WoNmFh9VYT0DFjWnHO9Ntf69QXIFYAbieEF54ZqcJYjE4sSkd8N4BdCLH9srnOu/1kO51dehbcrwLw0UN+dfEqFxxbZ1ptZhCwnZl/NItLNtuDJKBQKXR5YO2Qb8+kOnJ1XZLnJBE/YlTzENRsjKgGQnmdeeRO7/lqLHxr4q5sGB9YDJKkECTXs6ioN7q+6XevrIGg+v9hTLpc7rT8zt/AhzZYil6bicwtZ8YY/h+14LM1zZPnuc19SBRDdGLI+FEm2guCoE0B6CyT39m2QRcwyGgpH1gt/Cb7l2olW8Hx+sQdRJ5H0K5Dcee9/NRbGTHBk+RhZUS8X9+Z74kG+AY6RHdUSQnpsYAAdfxdb4ogFclki5PljVoHX4GAloFUpDy0NSPKzpS0kldb/Cd0PE2D5jKQ7wVXxf4onjNW29IfYrz4AAAAASUVORK5CYII=)
 */
export const ExperimentalMicrophoneSparkleMutedIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.78 17.22c-.25.25-.13.67.22.72V20H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-2.06A8 8 0 0 0 20 10a1 1 0 1 0-2 0 6 6 0 0 1-5.8 6 .52.52 0 0 0-.35.15l-1.07 1.07ZM15.4 4.6a.46.46 0 0 0 .1-.56 4 4 0 0 0-4.03-2c-.4.05-.47.57-.21.89A3.22 3.22 0 0 1 9.9 8l-1.16.43a.5.5 0 0 0-.3.3L8.01 9.9 8 9.94V10c0 .33.04.66.12.96.08.34.5.42.74.18L15.4 4.6ZM5.1 14.07c.17.26.53.3.75.08l.75-.75c.16-.16.19-.41.08-.62a5.99 5.99 0 0 1-.24-.51.62.62 0 0 0-.7-.35c-.23.05-.47.08-.7.08-.37 0-.7.34-.58.7.18.47.4.93.65 1.37Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9.2 3.86a1.21 1.21 0 0 1 0 2.28l-1.37.5a2 2 0 0 0-1.18 1.19l-.51 1.38a1.21 1.21 0 0 1-2.28 0l-.5-1.38a2 2 0 0 0-1.19-1.18L.79 6.14a1.21 1.21 0 0 1 0-2.28l1.38-.5a2 2 0 0 0 1.18-1.19L3.86.79a1.21 1.21 0 0 1 2.28 0l.5 1.38a2 2 0 0 0 1.19 1.18l1.38.51Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M22.7 1.3a1 1 0 0 1 0 1.4l-20 20a1 1 0 0 1-1.4-1.4l20-20a1 1 0 0 1 1.4 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
